module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage00"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "50%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "7%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("I")]), _vm._v(" disappeared on the night before my twelfth birthday. July 28, 1988. Only now can I at last tell the whole extraordinary story, the true story. Kensuke made me promise that I would say nothing, nothing at all, until at least ten years had passed. It was almost the last thing he said to me. I promised, and because of that I have had to live out a lie. I could let sleeping lies sleep on, but more than ten years have passed now. I have done school, done college, and had time to think. I owe it to my family and to my friends, all of whom I have deceived for so long, to tell the truth about my long disappearance, about how I lived to come back from the dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there is another reason for speaking out now, a far, far better reason. Kensuke was a great man, a good man, and he was my friend. I want the world to know him as I knew him.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("*  *  *  ")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Until I was nearly eleven, until the letter came, life was just normal. There were the four of us in the house: my mother, my father, me, and Stella — Stella Artois, that is, my one-ear-up and one-ear-down black-and-white sheepdog, who always seemed to know what was about to happen before it did. But even she could not have foreseen how that letter was going to change our lives forever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thinking back, there was a regularity, a sameness about my early childhood. Each morning, I went down the street to “the monkey school.” My father called it that because he said the children gibbered and screeched and hung upside down on the jungle gym on the playground. And, anyway, I was always “monkey face” to him — when he was in a playful mood, that is, which he often was. The school was really called St. Joseph’s, and I was happy there, for most of the time, anyway. After school every day, whatever the weather, I’d head down to the playground for soccer with Eddie Dodds, my best friend in all the world, and Matt and Bobby and the others. It was muddy down there. Sometimes the ball would just land hard and stick. We had our own team, the Mudlarks we called ourselves, and we were good, too. Visiting teams seemed to expect the ball to bounce for some reason, and by the time they realized it didn’t, we were often two or three goals ahead. We weren’t so good away from home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Every weekend I did a paper route from Mr. Patel’s shop on the corner. I was saving up for a mountain bike. I wanted to go mountain biking up on the moors with Eddie. The trouble was, I would keep spending what I’d saved. I’m still the same that way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sunday’s were always special, I remember. We’d go dinghy sailing, all of us, on the reservoir, Stella Artois barking her head off at the other boats as if they’d no right to be there. My father loved it, he said, because the air was clear and clean, no brick dust — he worked down at the brickworks. He was a great do-it-yourself fanatic. There was nothing he couldn’t fix, even if it didn’t need fixing. So he was in his element on a boat. My mother, who worked part-time in the office at the same brickworks, reveled in it, too. I remember her once, throwing back her head in the wind and breathing in deep as she sat at the tiller. “This is it,” she cried. “This is how life is supposed to be. Wonderful, just wonderful.” She always wore the blue cap. She was the undisputed skipper. If there was a breeze out there, she’d find it and catch it. She had a real nose for it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We had some great days on the water. We’d go out when it was rough, when no one else would, and we’d go skimming over the waves, exhilarating in the speed of it, in the sheer joy of it. And if there wasn’t a breath of wind, we didn’t mind that either. Sometimes we’d be the only boat on the whole reservoir. We’d just sit and fish instead — by the way, I was better at fishing than either of them — and Stella Artois would be curled up behind us in the boat, bored with the whole thing, because there was no one to bark at.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then the letter arrived. Stella Artois savaged it as it came through the letterbox. There were puncture holes in it and it was damp, but we could read enough. The brickworks were going to close down. They were both being laid off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a terrible silence at the breakfast table that morning. After that we never went sailing on Sundays anymore. I didn’t have to ask why not. They both tried to find jobs, but there was nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A creeping misery came over the house. Sometimes I’d come home and they just wouldn’t be speaking. They’d argue a lot, about little niggly things — and they had never been like that. My father stopped fixing things around the house. He was scarcely ever home, anyway. If he wasn’t looking for a job, he’d just sit at home, flicking through endless yachting magazines and saying nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried to stay out of the house and play soccer as much as I could, but then Eddie moved away because his father had found a job somewhere down south. Soccer just wasn’t the same without him. The Mudlarks disbanded. Everything was falling apart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then one Saturday I came home from my paper route and found my mother sitting at the bottom of the stairs and crying. She’d always been so strong. I’d never seen her like this before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Silly beggar,” she said. “Your dad’s a silly beggar, Michael, that’s what he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s he done?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s left us,” she told me, and I thought she meant for good. “He wouldn’t hear reason, oh no. He’s had this idea, he says. He wouldn’t tell me what it was, only that he’s sold the car, that we’re moving south, and he’s going to find us a place.” I was relieved, and quite pleased, really. South must be nearer to Eddie. She went on: “If he thinks I’m leaving this house, then I’m telling you he’s got another think coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?” I said. “Not much here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, there’s the house, for a start. Then there’s Grandma, and there’s school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s other schools,” I told her. She became steaming angry then, angrier than I’d ever known her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You want to know what was the last straw?” she said. “It was you, Michael, you going off on your paper route this morning. You know what your dad said? Well, I’ll tell you, shall I? ‘Do you know something?’ he says. ‘There’s only one lousy wage coming into this house — Michael’s paper money. How do you think that makes me feel, eh? My son’s eleven years old. He’s got a job, and I haven’t.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She steadied herself for a moment or two before she went on, her eyes filled with fierce tears. “I’m not moving, Michael. I was born here. And I’m not going. No matter what he says, I’m not leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was there when the phone call came a week or so later. I knew it was my father. My mother said very little, so I couldn’t understand what was going on, not until she sat me down afterward and told me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He sounds different, Michael. I mean, like his old self, like his very old self, like he used to be when I first knew him. He’s found us a place. ‘Just pack your stuff and come,’ he says. Fareham. Somewhere near Southampton. ‘Right on the sea,’ he says. There’s something very different about him, I’m telling you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My father did indeed seem a changed man. He was waiting for us when we got off the train, all bright-eyed again and full of laughter. He helped us with the suitcases. “It’s not far,” he said, ruffling my hair. “You wait till you see it, monkey face. I’ve got it all worked out, the whole thing. And it’s no good you trying to talk me out of it, either of you. I’ve made up my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll see,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stella Artois bounded along ahead of us, her tail held high and happy. We all felt like that, I think.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end we caught a bus because the suitcases were too heavy. When we got off we were right by the sea. There didn’t seem to be any houses anywhere, just a yachting marina.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are we doing here?” my mother asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s someone I want you to meet. A good friend of mine. She’s called Peggy Sue. She’s been looking forward to meeting you. I’ve told her all about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My mother frowned at me in puzzlement. I wasn’t any the wiser, either. All I knew for certain was that he was being deliberately mysterious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We struggled on with our suitcases, the gulls crying overhead, the yacht masts clapping around us, and Stella yapping at all of it, until at last he stopped right by a gangplank that led up to a gleaming dark blue yacht. He put the suitcases down and turned to face us. He was grinning from ear to ear. “Here she is,” he said. “Let me introduce you. This is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peggy Sue")]), _vm._v(". Our new home. Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering everything, my mother took it pretty well. She didn’t shout at him. She just went very quiet, and she stayed quiet all through his explanation down in the galley over a cup of tea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t a spur of the moment thing, you know. I’ve been thinking about it a long time, all those years working in the factory. All right, maybe I was just dreaming about it in those days. Funny when you think about it: If I hadn’t lost my job, I’d never have dared do it, not in a million years.” He knew he wasn’t making much sense. “All right, then. Here’s what I thought. What is it that we all love doing most? Sailing, right? Wouldn’t it be wonderful, I thought, if we could just take off and sail around the world? There’s people who’ve done it. Blue-water sailing, they call it. I’ve read about it in the magazines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like I said, it was just a dream to start with. And then, no job and no chance of a job. So why not a boat? We’ve got our severance pay, what little there was of it. There’s a bit saved up, and the car money. Not a fortune, but enough. What to do with it? I could put it all in the bank, like the others did. But what for? Just to watch it dribble away till there was nothing left? Or, I thought, I could do something really special with it, a once-in-a-lifetime thing: We could sail around the world. Africa. South America. Australia. The Pacific. We could see places we’ve only ever dreamed of.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We sat there completely dumbstruck. “Oh, I know what you’re thinking,” he went on. “You’re thinking, all we’ve ever done is reservoir sailing, dinghy sailing. You’re thinking, he’s gone crazy, loopy in the head. You’re thinking, it’s dangerous. You’re thinking, we’ll be flat broke. But I’ve thought it all out. I even thought of your grandma — there’s a thing. We won’t be gone forever, will we? She’ll be here when we get back, won’t she? She’s perfectly healthy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve got the money. I’ve done my math. We’re going to do six months’ training. We’ll be away a year, eighteen months maybe, just so long as the money lasts. We’re going to do it safe, do it properly. Mom, you’ll get your Yachtmaster’s certificate. Oh, didn’t I say? I didn’t, did I? You’ll be the skipper, Mom. I’ll be first mate and handyman. Michael, you’ll be ship’s boy, and Stella — well, Stella can be the ship’s cat.” He was full to it, breathless with excitement. “We’ll get ourselves in shape. Do a few trips across the Channel to France, maybe over to Ireland. We’ll get to know this boat like she’s one of us. She’s a forty-two foot. Bowman, best make, best design. Safest there is. I’ve done my homework. Six months’ time and we’ll be off around the world. It’ll be the adventure of a lifetime. Our one chance. We’ll never get another one. What do you think then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ex … cell … ent,” I breathed, and that was exactly what I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’ll be skipper, you say?” my mother asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aye aye, Cap’n,” my father said, and he laughed and gave her a mock salute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about Michael’s school?” she went on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve thought of that, too. I asked in the local school down here. It’s all arranged. We’ll take all the books he’ll need. I’ll teach him. You’ll teach him. He’ll teach himself. I’ll tell you something for nothing, he’ll learn more in a couple of years at sea than he ever would in that monkey school of his. Promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a sip of tea, and then nodded slowly. “All right,” she said, and I saw she was smiling. “Why not? Go ahead then. Buy her. Buy the boat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I already have,” said my father.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course it was madness. They knew it, even I knew it, but it simply didn’t matter. Thinking back, it must have been a kind of inspiration driven by desperation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everyone warned us against it. Grandma came visiting and stayed onboard. It was all quite ridiculous, she said, reckless, irresponsible. She was full of doom and gloom. Icebergs, hurricanes, pirates, whales, supertankers, freak waves — she heaped up horror upon horror, thinking to frighten me and so frighten off my mother and father. She succeeded in terrifying me, all right, but I never showed it. What she didn’t understand was that we three were already bound together now by a common lunacy. We were going, and nothing and no one could stop us. We were doing what people do in fairy tales. We were going off to seek adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To begin with, it all happened much as my father had planned it, except that the training took a lot longer. We soon learned that handling a forty-two-foot yacht was not just dinghy sailing in a bigger boat. We were tutored by a whiskered old mariner from the yacht club, Bill Parker (“Barnacle Bill,” we called him, but not to his face, of course). He had been twice around Cape Horn and had made two single-handed Atlantic crossings, and he’d been across the channel “more times than you’ve had hot dinners, my lad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To tell the truth, none of us liked him much. He was a hard taskmaster. He treated me and Stella Artois with equal disdain. To him, all animals and children were just a nuisance and, on board ship, nothing but a liability. So I kept out of his way as much as I could, and so did Stella Artois.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To be fair to him, Barnacle Bill did know his business. By the time he had finished with us, and my mother was given her certificate, we felt we could sail the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peggy Sue")]), _vm._v(" anywhere. He had inculcated in us a healthy respect for the sea but, at the same time, we were confident we could handle just about anything the sea could hurl at us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mind you, there were times I was scared stiff. My father and I shared our terror together, silently. You can’t pretend, I learned, with a towering green wall of water twenty feet high bearing down on you. We went down in troughs so deep, we never thought we could possibly climb out again. But we did, and the more we rode our terror, rode the waves, the more we felt sure of ourselves and of the boat around us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My mother, though, never showed even the faintest tremor of fear. She and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peggy Sue")]), _vm._v(" saw us through our worst moments. But she was seasick from time to time, and we never were. So that was something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We lived close, all of us, cheek by jowl, and I soon discovered parents were more than just parents. My father became my friend, my shipmate. We came to rely on each other. And as for my mother, the truth is — and I admit it — I didn’t know she had it in her. I had always known she was gritty, that she’d keep on at a thing until she’d done it. But she worked night and day over her books and charts until she had mastered everything. She never stopped. True, she could be a bit of a tyrant if we didn’t keep the boat shipshape, but neither my father nor I minded that much, though we pretended to. She was the skipper. She was going to take us around the world and back again. We had absolute confidence in her. We were proud of her. She was just brilliant. And, I have to say, the ship’s boy and the first mate were pretty brilliant, too, on the winches, at the helm, and with the baked beans in the galley. We were a great team.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So, on September 10, 1987 — I know the date because I have the ship’s log in front of me as I write — with every nook and cranny loaded with stores and provisions, we were at last ready to set sail on our grand adventure, our great odyssey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandma was there to wave us off, tearfully. In the end she even wanted to come with us, to visit Australia — she’d always wanted to see koalas in the wild. There were lots of our friends there, too, including Barnacle Bill. Eddie Dodds came, along with his father. He threw me a soccer ball as we cast off. “Lucky mascot!” he shouted. When I looked down at it later I saw he’d signed his name all over it like a World Cup star.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stella Artois barked her farewells at them, and at every boat we passed in The Solent. But as we were sailing out past the Isle of Wight, she fell strangely quiet. Maybe she sensed, as we did, that there was no turning back now. This was not a dream. We were off around the world. It was real, really real.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542e1330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545746076_ch001.vue
// module id = 69
// module chunks = 0